// extracted by mini-css-extract-plugin
export default {"form":"MealItemForm_form__H7lCF","button":"MealItemForm_button__dU7cw"};